import { getAll } from '@/api/produit/produitLocation';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { SENS_VENTE } from '@/configuration/devisConf';
import i18n from '@/i18n';
import { PRODUIT_ID_LOCATION_PAR_DEFAUT } from '@/configuration/societe/societe';

export function getLibelle(idProduitLoc, allProduitsLocation) {
  const produit = allProduitsLocation.find((produit) => {
    return produit.id === idProduitLoc;
  });
  return produit ? produit.libelle : null;
}

export async function getProduitLoc(sens) {
  const allProduitsLocation = (await getAll({
    orderBy: 'ProduitLocation.Quantite, Libelle',
    ascending: true,
    sens: sens,
    query: { actif: null, sens: sens },
    maxResultCount: NO_PAGINATION,
  })).data.result.items;
  if (sens === SENS_VENTE) {
    allProduitsLocation.push({ id: PRODUIT_ID_LOCATION_PAR_DEFAUT, libelle: i18n.t('societes.produitLocDefaut.produitLocationDefaut') });
  }
  return allProduitsLocation;
}

export async function getLibelleProduitLocDefaut(societe) {
  const allProduitsLocation = await getProduitLoc(SENS_VENTE);
  const produitLoc = {
    unitaire: getLibelle(societe.produitIdDefautUnitaire, allProduitsLocation),
    regroupement: getLibelle(societe.produitIdDefautRegroupement, allProduitsLocation),
    regroupementNumerique: getLibelle(
      societe.produitIdDefautRegroupementNumerique, allProduitsLocation,
    ),
    ecranNumerique: getLibelle(societe.produitIdDefautEcranNumerique, allProduitsLocation),
    regroupementLc: getLibelle(societe.produitIdDefautRegroupementLc, allProduitsLocation),
  };

  const produitAssocieLocDefaut = {
    face: getLibelle(societe.produitAssocieLocationFaceId, allProduitsLocation),
    ecranNum: getLibelle(societe.produitAssocieLocationEcranNumId, allProduitsLocation),
    reseauTempo: getLibelle(
      societe.produitAssocieLocationReseauTempoId, allProduitsLocation,
    ),
    reseauLc: getLibelle(societe.produitAssocieLocationReseauLcId, allProduitsLocation),
    reseauNum: getLibelle(societe.produitAssocieLocationReseauNumId, allProduitsLocation),
  };
  return { produitsLocation: produitLoc, produitAssocieLocation: produitAssocieLocDefaut };
}
